<template>
  <div class="nav_warp" :class="{navFixe:classFixe}">
    <div class="nav">
      <dl>
        <dt>
          <div class="logoMars3">
            <router-link to="/index"> <img
                src="//cdn1.zygames.com/qqsm/Public/img/version/mars3logo.png"
                alt=""
                srcset=""
              ></router-link>

          </div>
        </dt>
        <dd>
          <router-link to="/e1" class="navText">
            <p>超值商品</p>
            <p>限时销售</p>
          </router-link>
        </dd>
        <dd>
          <router-link to="/e2" class="navText">
            <p>免费福利</p>
            <p>大升级</p>
          </router-link>
        </dd>
        <dd>
          <router-link to="/e3" class="navText">
            <p>每日任务</p>
            <p>奖励大升级</p>
          </router-link>
        </dd>
        <dd>
          <router-link to="/e4" class="navText">
            <p class="only1List">新兵有福利</p>
          </router-link>
        </dd>
        <dd>
          <router-link to="/e5" class="navText">
            <p class="only1List">多倍狂欢</p>
          </router-link>
        </dd>
        <dd>
          <router-link to="/e6" class="navText">
            <p class="only1List">限时豪礼</p>
          </router-link>
        </dd>
      </dl>
      <div class="goHome">
        <a href="http://qqsm.zygames.com/main.html" target="_blank" rel="noopener noreferrer">官网首页</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "versionNav",
  data() {
    return {
      classCssOn: false,
      classFixe:false
    };
  },
  mounted(){
    window.addEventListener('scroll',this.navShow)
  },
  destroyed () {
    // window.removeEventListener('scroll', this.navShow)
  },
  methods: {
    cssOn() {
      this.classCssOn = true;
    },
    navShow(){
      var scrollTop= window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 200) {
        this.classFixe = true;
       
      } else {
        this.classFixe = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.nav_warp {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: rgba(0,0,0,0.6);
  color: #fff;
  font-size: 16px;
  .nav {
    width: 1200px;
    height: 78px;
    margin: 0 auto;
    dl {
      cursor: pointer;
      dt {
        float: left;
        .logoMars3 {
          width: 200px;
          height: 45px;
          margin-top: 15px;
          a {
            width: 186px;
            height: 45px;
            overflow: hidden;
            img {
              width: 186px;
              height: 44px;
            }
          }
        }
      }
      dd {
        float: left;
        position: relative;
        margin-left: 40px;

        .navText {
          display: inline-block;
          color: #fff;
          line-height: 24px;
          width: 96px;
          height: 48px;
          padding: 15px 0;
          text-align: center;
          .only1List {
            line-height: 48px;
          }
        }
        &:hover .navText::after {
          content: "";
          width: 100%;
          height: 5px;
          background-color: #fff;
          position: absolute;
          bottom: 0;
          left: 0;
        }
        .router-link-active::after {
          content: "";
          width: 100%;
          height: 5px;
          background-color: #fff;
          position: absolute;
          bottom: 0;
          left: 0;
        }
      }
    }
    .goHome {
      float: right;
      // width: 128px;
      // height: 45px;
      // font-weight: bold;
      // text-align: center;
      // background-color: #0099cc;
      // font-size: 20px;
      // padding: 2px;
      margin-top: 15px;
      a {
        // width: 200px;
        // font-size: 16px;
        // font-weight: 600;
        cursor: pointer;
        display: block;
        margin: 5px;
        height: 55px;
        text-align:center;
        border: none;
        background-size: 300% 100%;
        border-radius: 5px;
        -moz-transition: all .4s ease-in-out;
        -o-transition: all .4s ease-in-out;
        -webkit-transition: all .4s ease-in-out;
        transition: all .4s ease-in-out;
        width: 124px;
        height: 41px;
        line-height: 40px;
        // letter-spacing: 0.33rem;
        color: #fff;
        // background-image: linear-gradient(to right, #25aae1, #4481eb, #04befe, #3f86ed);
        // box-shadow: 0 4px 15px 0 rgba(65, 132, 234, 0.75);
        background-image: linear-gradient(to right, #f00, #c11616, #fe0404, #a11);
        box-shadow: 0 3px 10px 0 rgba(198, 24, 24, 0.75);
        &:hover {
          background-position: 100% 0;
          -moz-transition: all .4s ease-in-out;
          -o-transition: all .4s ease-in-out;
          -webkit-transition: all .4s ease-in-out;
          transition: all .4s ease-in-out;
        }
      }
    }
  }
}

.navFixe{
  position:fixed;
  background-color: rgba(0, 0, 0,0.6);
  animation:showSlow 1s ;
}

@keyframes showSlow {
  0%{
  background-color: rgba(0, 0, 0, 0);
  }
  100%{
  background-color: rgba(0, 0, 0, 0.6);
  }
}

</style>















// WEBPACK FOOTER //
// src/components/qqsmVersion_nav.vue